const navbarStrings = {
    home: 'Home',
    menu: 'Menu',
    locationAndContact: 'Location & Contact',
};

export default navbarStrings;
